import { memo } from 'react';

interface DataTabIconProperties {
  size?: number;
}

/** Figma: table-list (16×16) */
const DataTabIcon = memo(({ size = 16 }: DataTabIconProperties) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      d='M12.6667 1.33301H3.33333C1.49533 1.33301 0 2.82834 0 4.66634V11.333C0 13.171 1.49533 14.6663 3.33333 14.6663H12.6667C14.5047 14.6663 16 13.171 16 11.333V4.66634C16 2.82834 14.5047 1.33301 12.6667 1.33301ZM1.33333 6.66634H4V9.33301H1.33333V6.66634ZM5.33333 6.66634H14.6667V9.33301H5.33333V6.66634ZM14.6667 4.66634V5.33301H5.33333V2.66634H12.6667C13.7693 2.66634 14.6667 3.56367 14.6667 4.66634ZM3.33333 2.66634H4V5.33301H1.33333V4.66634C1.33333 3.56367 2.23067 2.66634 3.33333 2.66634ZM1.33333 11.333V10.6663H4V13.333H3.33333C2.23067 13.333 1.33333 12.4357 1.33333 11.333ZM12.6667 13.333H5.33333V10.6663H14.6667V11.333C14.6667 12.4357 13.7693 13.333 12.6667 13.333Z'
      fill='black'
    />
  </svg>
));

DataTabIcon.displayName = 'DataTabIcon';

export default DataTabIcon;
